// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2SA77","inputDescription":"styles_inputDescription__A6qqX"};